import initBranding from '~/plugins/config/initBranding'
import loadEnvConfig from '~/plugins/config/loadEnvConfig'
import loadBrandingConfig from '~/plugins/config/loadBrandingConfig'

let branding = null

const ConfigPlugin = async (context, inject) => {
  branding = await initBranding(context.query.brand)
  const envConfig = await loadEnvConfig()
  const navigation = await loadBrandingConfig('navigation')
  const i18n = await loadBrandingConfig('i18n')
  const logos = await loadBrandingConfig('logos')
  const flags = await loadBrandingConfig('flags')
  const brandedConfig = await loadBrandingConfig('brandedConfig')

  inject('envConfig', {
    ...envConfig,
    navigation,
    i18n,
    logos,
    flags,
    brandedConfig,
    branding
  })
}

export default ConfigPlugin
